import { Icon, IconProps } from '@chakra-ui/react'

export default function MapIcon(props: IconProps) {
  return (
    <Icon
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      color={'#868E96'}
      {...props}
    >
      <path
        d="M14 7.00008V4.00008C14 3.2637 13.403 2.66675 12.6667 2.66675H6"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4 14.0001H7.33333"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        cx="4"
        cy="12"
        r="2"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2 11.9999V3.33325C2 2.22868 2.89543 1.33325 4 1.33325C5.10457 1.33325 6 2.22868 6 3.33325V11.9999"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.33334 13.0001V11.0001C9.33335 10.6963 9.47145 10.409 9.70868 10.2192L11.3753 8.88588C11.7406 8.5937 12.2595 8.5937 12.6247 8.88588L14.2914 10.2192C14.5286 10.409 14.6667 10.6963 14.6667 11.0001V13.0001C14.6667 13.5524 14.219 14.0001 13.6667 14.0001H10.3333C9.78106 14.0001 9.33334 13.5524 9.33334 13.0001Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  )
}
